module.exports = __webpack_public_path__ + "static/media/ABENT3.crop.99618385.jpg";